if (jQuery(".contact-page").length > 0) {
    let map;
    let marker;
    let geocoder;

    let contact = jQuery(document).find(".contact-block");
    var initMap =  function() {

            map = new google.maps.Map(document.getElementById("map"), {
                center: {lat: 45.497080, lng: 9.182620},
                zoom: 18,
                mapTypeControl: false,
                zoomControl: false,
                scaleControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            });
            geocoder = new google.maps.Geocoder();

            marker = new google.maps.Marker({
                map,
            });

            for (const element of contact) {
                element.addEventListener("click", () =>
                    toggleItem(element)
                );
            }

            var toggleItem =  function (element) {
                let $itemActive = document.querySelector(".activeContactMap");
                let sameElem = false;
                if ($itemActive) {
                    closeItem($itemActive);
                    sameElem = $itemActive.querySelector(".contact-block");
                }
                if (!sameElem) {
                    openItemClick(element);
                }
            }

            var closeItem = function($element) {
                $element.classList.remove("activeContactMap");
            }

            var openItem =  function ($element) {
                $element.classList.add("activeContactMap");
                geocode({placeId: $element.getAttribute('data-address')});
            }

            var openItemClick =  function ($element){
                $element.classList.add("activeContactMap");
                geocode({placeId: $element.getAttribute('data-address')});
                let city = $element.querySelector("h4").innerHTML;

                trackingEventPiwik(_paq, ["trackEvent", "Mappa", "Click", city])


                if (window.matchMedia('(min-width: 770px)').matches) {
                    jQuery('html, body').animate({scrollTop: jQuery(".contact-map").offset().top - 100}, "2s");
                }
                if (window.matchMedia('(max-width: 769px)').matches) {
                    jQuery('html, body').animate({scrollTop: jQuery("#map").offset().top - 175}, "2s");
                }
            }


            let defaultElement = document.querySelector(".contact-block-initial");
            if (defaultElement) {
                openItem(defaultElement);
            }


        }


    var clear = function() {
        marker.setMap(null);
    }

    var geocode = function(request) {
        clear();
        geocoder
            .geocode(request)
            .then((result) => {
                const {results} = result;

                map.setCenter(results[0].geometry.location);
                marker.setPosition(results[0].geometry.location);
                marker.setMap(map);
                return results;
            })
            .catch((e) => {
                console.log("Geocode was not successful for the following reason: " + e);
            });
}

    jQuery(window).load(function () {
        initMap();
    });

}
